import {
  ui,
  storage,
  device,
  link,
  net,
  envVar,
  i18n,
  region,
  message,
  envFn,
  cache,
  _money,
  eventInit,
  pageDestoryListener,
} from "@platform/index"
import { migrate } from "../android/migrate"
import { globalInfo } from "../share/env/util"
import { isEmpty } from "../utils/index"
import { _default } from "./ctx"

declare let globalThis: any

const sn = cache?.get("__sn__") || undefined
if (!sn) {
  device.getSerialNumber().then((res) => {
    if (res) cache.set("__sn__", res)
  })
}

/**
 * 初始化DSL
 */
export const initDSL = function (config: {
  linkConfig?: Parameters<typeof link.init>[0]["getConfig"]
  serviceCall?: Parameters<typeof net.init>[0]["getConfig"]
  ui?: Parameters<typeof ui.init>[0]
  env?: string
  envMap?: Parameters<typeof envVar.init>[0]
  lang?: string
  defaultLang?: string
  langSupport?: string[]
  max?: Max
  shortKey?: string
  serviceCallEnv?: string
  appInfo?: AppInfo
  login?: Tlogin
  migrate?: Migrate
  moneyConfig?: AllMoneyConfig
  defaultCurrency?: TCurrency
  isAppWorker?: boolean
  officialCloudApi?: any[]
  // 全局浮层配置
  overlayConfigs?: any[]
  // web灰度配置
  grayConfig?: { switching: "ON" | "OFF", key?: string }
}) {
  const {
    linkConfig,
    serviceCall,
    ui: _ui,
    envMap,
    env,
    lang,
    defaultLang,
    langSupport,
    appInfo,
    login = {},
    migrate: _migrate,
    moneyConfig,
    defaultCurrency,
    isAppWorker = false,
    officialCloudApi = [],
    overlayConfigs,
    grayConfig
  } = config

  globalThis.__isAppWorker__ = isAppWorker

  globalInfo?.set("__isAppWorker__", isAppWorker)

  // 缓存浮层配置
  globalInfo?.set("overlayConfigs", overlayConfigs)
  // appWorker过滤不支持的TinyApi
  if (!isAppWorker) {
    eventInit()
    pageDestoryListener()
  }

  // 初始化iot相关配置
  linkConfig && link.init({ getConfig: linkConfig })

  // 初始化网络相关配置
  serviceCall && net.init({ getConfig: serviceCall }, config?.serviceCallEnv, _migrate)

  // 初始化ui相关配置
  ui.init(_ui)

  // 初始化localStorage
  storage.init()

  // 初始化环境变量相关配置
  envMap && envVar.init(envMap)

  // 初始化环境相关配置
  env && envFn.setEnv(env)

  // 端侧同步变量给运行时
  if (__platform === "android") {
    envMap && TinyAPI?.envVar?.setEnvList!(Object.keys(envMap))
  }

  // 初始化应用相关信息
  if (!isEmpty(appInfo)) {
    if (appInfo?.region && appInfo?.regionServerSupportedMap) {
      region.init(appInfo?.region, appInfo?.regionServerSupportedMap) // 设置默认region
    }
    globalInfo.init(appInfo) // 初始化app Info

    // 端侧底层会帮助处理message init
    if (__platform !== "android") {
      message.init({
        // 初始化message
        appId: appInfo?.appId,
        tenantCode: appInfo?.tenantCode,
        env: env,
        serviceCallEnv: config?.serviceCallEnv,
      })
    }
    if (__platform === "android") {
      _migrate && migrate.init(_migrate, appInfo?.tenantCode, env)
    }
  }

  // 是否开启sunmi登录鉴权
  if (Object.keys(login).length) {
    globalInfo?.set?.("login", login)
  }

  // 初始化多语言相关配置
  langSupport && i18n.setLangList(langSupport)
  lang && defaultLang && i18n.init(lang, defaultLang)

  // 初始化money相关配置
  defaultCurrency &&
    !isEmpty(moneyConfig) &&
    _money.init({ moneyConfig, defaultCurrency })

  // 初始化migrate相关配置
  // 解析所有一方cloud，生成 max.lib.服务包.API 作用域
  if (officialCloudApi && officialCloudApi.length > 0) {
    officialCloudApi?.forEach((i) => {
      const [pkg, api] = i.serviceName.split('.')
      // @ts-ignore
      _default.register(`lib.${pkg}.${api}`, (...arg) => net.serviceCall(i.serviceName, ...arg))
    })
  }

  // web灰度
  if (grayConfig) {
    globalInfo?.set("grayConfig", grayConfig)
  }
}
